import React from 'react'

import Loading from '@components/Loading'
import { useHasContainedLoader } from '@components/Loading/containedRegistry'

import { useIsFetching, useIsMutating } from '@tanstack/react-query'
import { loadableMutations, loadableQueries } from '@queries/Keys'

const Loader = () => {
  const isMutating = useIsMutating({
    predicate: (mutation) => {
      const key = mutation?.options?.mutationKey?.[0]
      return loadableMutations.includes(key as string)
    },
  })
  const isFetching = useIsFetching({
    predicate: (query) => {
      const key = Array.isArray(query.queryKey) ? query.queryKey[0] : query.queryKey
      return loadableQueries.includes(key)
    },
  })
  const hasPageLoader = useHasContainedLoader()

  // Mirrors the web shell in src/App.tsx -- the list pages are shared between
  // the two builds, so the duplicate-spinner and click-swallowing behaviour was
  // identical in the Teams embed. See the comments there.
  if (isMutating) return <Loading loading />

  return <Loading loading={!!isFetching && !hasPageLoader} blocking={false} />
}

export default Loader
